module.exports = __webpack_public_path__ + "static/media/profile-11.3fa699ce.jpg";